export default {"src":"/_next/static/media/close_icon.40af4186.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};